export const TRACK_PIXEL = "lead/track_pixel";
export const TRACK_PIXEL_DONE = "lead/track_pixel_done";
export const TRACK_PIXEL_FAILED = "lead/track_pixel_failed";
